/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";
import Cookies from "js-cookie";
import login from "@/views/login";
import Home from "@/views/Home";
import Refresh from "@/views/Refresh/Refresh";
import defaultPage from "@/views/defaultPage/defaultPage";
import StaffAdd from "@/views/pages/System/StaffAdd";
import BasicPriceAdd from "@/views/pages/System/BasicPriceAdd";
import BasicPriceAddCus from "@/views/pages/System/BasicPriceAddCus";
import BasicPriceAddCusPro from "@/views/pages/System/BasicPriceAddCusPro";
import CusInformation from "@/views/pages/System/CusInformation";
// import FinishedDetails from "@/views/pages/SystemBill/FinishedDetails";
// import OrderDetailAdd from "@/views/pages/BillBusiness/OrderDetailAdd";
// import OrderProductDetail from "@/views/pages/BillBusiness/OrderProductDetail";
import personal from "@/views/personal/personal";
import store from "@/store";
import api from "@/api/api";
import { Message } from "element-ui";
import { localStorageGet } from "@/utils/localStorageGet";
Vue.use(Router);
// let iconFont = ['iconweibiaoti2010104','iconchuangkoufangda','iconliucheng']
let iconFont = ['@/assets/images/icon-1.png','@/assets/images/基础档案.png','@/assets/images/基础档案 (2).png']
let iconFontChild = ['iconchuangkoufangda','iconchuangkou','iconliucheng','iconbiaoge-cengji','iconcengji','iconfanshenhe','iconhuaban','icontijiao','iconzhankai','iconzhankai1',
 'iconxiaoshouguanli','iconcaigouguanli','icondayin','iconyulan','iconbaocun1','iconweibiaoti2010104','iconshanchu1','iconexport','iconzengjia','icondaochu','iconwenjian_f']
const router = new Router({
  routes: [
    {
      path: "/index",
      component: Home,
      children: [
        {
          path: "",
          name: "系统介绍",
          component: defaultPage,
          meta: {
            index: 0,
            keepalive: true
          }
        },
        {
          path: "personal",
          name: "个人中心",
          component: personal,
          meta: {
            index: -1,
            keepalive: true
          }
        },
        {
          path: "refresh",
          name: "刷新",
          component: Refresh,
          meta: {
            index: -2
          }
        },
        {
          path: "StaffAdd",
          name: "添加员工",
          component: StaffAdd,
          meta: {
            index: -5
          }
        },
        {
          path: "BasicPriceAdd",
          name: "添加区域价格本",
          component: BasicPriceAdd,
          meta: {
            index: -6
          }
        },
        {
          path: "BasicPriceAddCus",
          name: "添加客户价格本",
          component: BasicPriceAddCus,
          meta: {
            index: -8
          }
        },
        {
          path: "BasicPriceAddCusPro",
          name: "添加客户项目价格本",
          component: BasicPriceAddCusPro,
          meta: {
            index: -9
          }
        },
        {
          path: "CusInformation",
          name: "往来单位信息详细",
          component: CusInformation,
          meta: {
            index: -7
          }
        },
        // {
        //   path: "FinishedDetails",
        //   name: "产品BOM表部件详情",
        //   component: FinishedDetails,
        //   meta: {
        //     index: -8
        //   }
        // },
        // {
        //   path: "OrderDetailAdd",
        //   name: "拆单",
        //   component: OrderDetailAdd,
        //   meta: {
        //     index: -9
        //   }
        // },
        // {
        //   path: "OrderProductDetail",
        //   name: "生产计划分类明细",
        //   component: OrderProductDetail,
        //   meta: {
        //     index: -10
        //   }
        // },
      ]
    },
    {
      path: "/login",
      name: "login",
      component: login
    },
    {
      path: "/", //这个表示的是根目录，即一进入的页面
      redirect: "login"
    }
  ]
});

router.beforeEach((to, from, next) => {
  // console.log("=====>", to, from, next);
  if (to.path === "/") {
    to.path = "index/personal";
  }
  to.meta.keepalive = true;
  let token = localStorageGet("token");
  // console.log(to.path)
  if (to.path === "/login") {
    if (token) {
      next({ path: "/index" });
    } else {
      next();
    }
  } else {
    if (!token) {
      Message({ message: "登录时间过久,请重新登录!", type: "error" });
      localStorage.removeItem("roleId");
      store.commit("RouterLoad", false);
      store.commit("updateTabList", []);
      store.commit("updateActiveTab", "");
      next({ path: "/login" });
    } else {
      // 加载动态菜单和路由
      DynamicRouter();
      next();
    }
  }
});
router.afterEach((to, from, next) => {
  if (store.state.tabs.TabList.filter(children => children.name === from.name)[0]) {
  } else {
    from.meta.keepalive = false;
  }
});
function DynamicRouter () {
  if (store.state.app.RouterLoad) {
    return;
  }
  router.options.routes[0].children = [];
  let info = { roleId: localStorage.roleId };
  //就是在这里调用 api.user.userMenu 接口

  let userId = null;
  try {
    userId = JSON.parse(localStorage.getItem("personal")).id
  } catch (error) {
  }
  // console.log(userId)
  let ids = []
  ids.push(Number(localStorage.userId))
  api.user.userMenu({ids:ids}).then(res => {
    //api.menu.tree({ system:  }).then(res => {
    if (res.code == 0) {
      let arr = []
      for (let i in res.data) {
        if (i<(res.data.length-1)) {
          // res.data[i].label = iconFont[i]
          // if (res.data[i].item) {
          //   for (let j in res.data[i].item) {
          //     res.data[i].item[j].label = iconFontChild[j]
          //   }
          // }
          arr.push(res.data[i])
        }
      }
      localStorage.userButtonList = JSON.stringify(res.data[res.data.length - 1])
      // //添加路由
      let menuRoute = addDynamicRoutes(arr);
      // 处理静态组件绑定路由
      handleStaticComponent(router, menuRoute);
      router.addRoutes(router.options.routes);
      //保存加载状态
      store.commit("RouterLoad", true);
      // 保存菜单树
      // console.log(arr)
      store.commit("menuList", arr);
    }
  });
}
function addDynamicRoutes (menuList = [], routes = []) {
  var temp = [];
  for (var i = 0; i < menuList.length; i++) {
    if (menuList[i].bindStatus == 0) continue;
    // console.log(menuList[i].item)
    if (menuList[i].item && menuList[i].item.length >= 1) {
      temp = temp.concat(menuList[i].item);
      // if (menuList[i].item.item) {
      //   for (let inde of menuList[i].item.item) {
      //     temp = temp.concat(inde.item);
      //   }
      // }
    } else if (menuList[i].path && /\S/.test(menuList[i].path)) {
      menuList[i].path = menuList[i].path.replace(/^\//, "");
      // 创建路由配置
      var route = {
        path: menuList[i].path,
        component: null,
        name: menuList[i].menu_name,
        meta: {
          index: menuList[i].menu_id,
          keepalive: true
        }
      };
      try {
        // 根据菜单URL动态加载vue组件，这里要求vue组件须按照url路径存储
        // 如url="sys/user"，则组件路径应是"@/views/sys/user.vue",否则组件加载不到
        let array = menuList[i].path.split("/");
        let url = "";
        for (let i = 0; i < array.length; i++) {
          url +=
            array[i].substring(0, 1).toUpperCase() +
            array[i].substring(1) +
            "/";
        }
        url = url.substring(0, url.length - 1);
        route["component"] = resolve =>
          require([`@/views/pages/${url}`], resolve);
      } catch (e) { }
      routes.push(route);
    }
  }
  if (temp.length >= 1) {
    addDynamicRoutes(temp, routes);
  }
  return routes;
}
function handleStaticComponent (router, menuRoute) {
  // console.log(router, menuRoute)
  router.options.routes[0].children = router.options.routes[0].children.concat(
    menuRoute
  );
}
export default router;
/* eslint-disable */



// WEBPACK FOOTER //
// ./src/router/index.js